import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BreadcrumbsBase from "../components/buttons/Breadcrumbs";
import AddTopicForm from '../components/forms/AddTopicForm'

import { $host } from "../../../http";
import generateBreadcrumbs from "../utils/breadcrumbs";

import { useNotifications } from "../../../store/NotificationContext";

const SingleTopic = () => {
    const {theme_id: themeId} = useParams()

    const [theme, setTheme] = useState()
    const [breadcrumbs, setBreadcrumbs] = useState([])
    const {showNotification} = useNotifications()

    useEffect(() => {
        (async () => {
            try {
                const {data} = await $host.get(`/api/students/themes/${themeId}`)
                const {homework_id} = data.theme
                
                setTheme({
                    ...data.theme,
                    homework_id: parseInt(homework_id) === 0 ? null : homework_id
                })
                setBreadcrumbs(generateBreadcrumbs(data.breadcrumbs))
            } catch(e) {
                console.error(e)
            }
        })();
    }, [themeId])

    const editTheme = async data => {
        try {
            await $host.request(
                `/api/teachers/themes/${themeId}`,
                {
                    method: 'PUT',
                    data: JSON.stringify(data)
                }
            )
            showNotification('Тема успешно обновлена')
        } catch (e) {
            console.error(e)
        }
    }
    
    const createThemeHomework = async () => {
        try {
            const result = await fetch(
                `/api/teachers/homeworks/${themeId}`,
                {
                    method: 'POST',
                    body: JSON.stringify({})
                }
            )
            const response = await result.json()
            const hw = response.body
            setTheme({...theme, homework_id: hw.id})
        } catch (e) {
            console.error(e)
        }
    }

    return ( 
        <section className="py-10 pl-6 px-6 w-full">
            <BreadcrumbsBase items={breadcrumbs} />
            {
                theme && <AddTopicForm data={theme} updateData={setTheme} onSubmit={editTheme} createHW={createThemeHomework} />
            }
        </section>
    )
}

export default SingleTopic